var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.data
    ? _c("div", { staticClass: "vx-row" }, [
        _c(
          "div",
          { staticClass: "vx-col lg:w-1/2 w-full" },
          [
            _c(
              "vx-card",
              [
                _c("h4", { staticClass: "mb-4" }, [
                  _vm._v(_vm._s(_vm.$t("cancellation.index_by_establishment"))),
                ]),
                _vm._l(_vm.data.by_establishment, function (entity) {
                  return _c(
                    "div",
                    { key: entity.legal_entity_id, staticClass: "mb-3" },
                    [
                      _c("div", { staticClass: "flex justify-between mb-50" }, [
                        _c("small", { staticClass: "text-muted" }, [
                          _vm._v(_vm._s(entity.name)),
                        ]),
                        _c(
                          "small",
                          {
                            staticClass: "font-medium",
                            class: "text-" + _vm.rateColor(entity.rate),
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.formatRate(entity.rate)) + " "
                            ),
                          ]
                        ),
                      ]),
                      _c(
                        "b-progress",
                        { attrs: { max: 20, height: "8px" } },
                        [
                          _c("b-progress-bar", {
                            attrs: {
                              value: entity.rate,
                              variant: _vm.rateColor(entity.rate),
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                }),
                _c(
                  "div",
                  { staticClass: "flex justify-between border-top pt-3" },
                  [
                    _c("small", { staticClass: "text-muted" }, [
                      _vm._v(_vm._s(_vm.$t("cancellation.index_platform_avg"))),
                    ]),
                    _c("small", { staticClass: "font-medium" }, [
                      _vm._v(_vm._s(_vm.formatRate(_vm.data.platform_rate))),
                    ]),
                  ]
                ),
              ],
              2
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "vx-col lg:w-1/2 w-full" },
          [
            _c(
              "vx-card",
              { staticClass: "mb-4" },
              [
                _c("h4", { staticClass: "mb-3" }, [
                  _vm._v(_vm._s(_vm.$t("cancellation.index_origin"))),
                ]),
                _c(
                  "b-progress",
                  { staticClass: "mb-2", attrs: { max: 100, height: "12px" } },
                  [
                    _c("b-progress-bar", {
                      attrs: {
                        value: _vm.data.origins.student,
                        variant: "primary",
                      },
                    }),
                    _c("b-progress-bar", {
                      attrs: {
                        value: _vm.data.origins.establishment,
                        variant: "warning",
                      },
                    }),
                    _c("b-progress-bar", {
                      attrs: {
                        value: _vm.data.origins.payment_failure,
                        variant: "danger",
                      },
                    }),
                  ],
                  1
                ),
                _c("div", { staticClass: "flex justify-between mb-50" }, [
                  _c("small", { staticClass: "text-muted" }, [
                    _c("span", {
                      staticClass: "bullet bullet-primary bullet-sm mr-50",
                    }),
                    _vm._v(_vm._s(_vm.$t("cancellation.origin_.ST")) + " "),
                  ]),
                  _c("small", [_vm._v(_vm._s(_vm.data.origins.student) + "%")]),
                ]),
                _c("div", { staticClass: "flex justify-between mb-50" }, [
                  _c("small", { staticClass: "text-muted" }, [
                    _c("span", {
                      staticClass: "bullet bullet-warning bullet-sm mr-50",
                    }),
                    _vm._v(_vm._s(_vm.$t("cancellation.origin_.ES")) + " "),
                  ]),
                  _c("small", [
                    _vm._v(_vm._s(_vm.data.origins.establishment) + "%"),
                  ]),
                ]),
                _c("div", { staticClass: "flex justify-between" }, [
                  _c("small", { staticClass: "text-muted" }, [
                    _c("span", {
                      staticClass: "bullet bullet-danger bullet-sm mr-50",
                    }),
                    _vm._v(_vm._s(_vm.$t("cancellation.origin_.PF")) + " "),
                  ]),
                  _c("small", [
                    _vm._v(_vm._s(_vm.data.origins.payment_failure) + "%"),
                  ]),
                ]),
              ],
              1
            ),
            _c(
              "vx-card",
              [
                _c("h4", { staticClass: "mb-3" }, [
                  _vm._v(_vm._s(_vm.$t("cancellation.index_modality"))),
                ]),
                _c(
                  "b-table-simple",
                  { attrs: { small: "", responsive: "" } },
                  [
                    _c(
                      "b-thead",
                      [
                        _c(
                          "b-tr",
                          [
                            _c("b-th", [
                              _vm._v(_vm._s(_vm.$t("cancellation.modality"))),
                            ]),
                            _c("b-th", [
                              _vm._v(_vm._s(_vm.$t("cancellation.teacher"))),
                            ]),
                            _c("b-th", { staticClass: "text-right" }, [
                              _vm._v(_vm._s(_vm.$t("cancellation.rate"))),
                            ]),
                            _c("b-th", { staticClass: "text-right" }, [
                              _vm._v(
                                _vm._s(_vm.$t("cancellation.rescheduled"))
                              ),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-tbody",
                      [
                        _vm._l(_vm.data.by_product, function (row, i) {
                          return _c(
                            "b-tr",
                            { key: i },
                            [
                              _c("b-td", [_vm._v(_vm._s(row.modality))]),
                              _c("b-td", [_vm._v(_vm._s(row.teacher || "—"))]),
                              _c("b-td", { staticClass: "text-right" }, [
                                _vm._v(_vm._s(_vm.formatRate(row.rate))),
                              ]),
                              _c("b-td", { staticClass: "text-right" }, [
                                _vm._v(_vm._s(row.rescheduled) + "%"),
                              ]),
                            ],
                            1
                          )
                        }),
                        !_vm.data.by_product.length
                          ? _c(
                              "b-tr",
                              [
                                _c(
                                  "b-td",
                                  {
                                    staticClass: "text-center text-muted",
                                    attrs: { colspan: "4" },
                                  },
                                  [_vm._v("Nenhum registro encontrado")]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      2
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }